/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ToolsInputs */

const en_mk_foot_tools = /** @type {(inputs: Mk_Foot_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools ranking`)
};

const id_mk_foot_tools = /** @type {(inputs: Mk_Foot_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat tools`)
};

/**
* | output |
* | --- |
* | "Tools ranking" |
*
* @param {Mk_Foot_ToolsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_tools = /** @type {((inputs?: Mk_Foot_ToolsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ToolsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_tools(inputs)
	return en_mk_foot_tools(inputs)
});